import React, { FC } from "react";
import { Container, Typography } from "@mui/material";
import Product from "./Product";
import { Product as ProductType } from "../../api/homepage";

const ProductList: FC<{ products: ProductType[] | [] }> = ({ products }) => {
  return (
    <Container sx={{ marginTop: 4 }}>
      <Typography
        sx={{
          fontWeight: "bold",
          textAlign: "center",
          textTransform: "none",
          fontFamily: "Poppins, sans-serif",
          fontSize: { xs: "30px", sm: "48px" },
          marginBottom: 4,
        }}
      >
        Explore our craft beers
      </Typography>
      <Typography
        sx={{
          fontWeight: "regular",
          marginBottom: 4,
          textAlign: "center",
          textTransform: "none",
          fontFamily: "Poppins, sans-serif",
          fontSize: "18px",
        }}
      />
      {products.map((product, index) => (
        <Product
          id={product.id}
          key={product.id}
          name={product.name}
          description={product.description}
          abv={product.abv.toString()}
          image={product.imageMasterUrl}
          ibu={product?.ibu?.toString() ?? "N/A"}
          showBuyButton={index < 2}
          reverse={index % 2 === 1} // Alternate layout for even and odd indices
        />
      ))}
    </Container>
  );
};

export default ProductList;
